import { Typography } from "@mui/material";

import { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";
import { getButtonsConfig } from "../../config/buttonsConfig";

import GenericModal from "./GenericModal";

export default function WarningModal({ additionalDetails = {} }) {
  const BUTTONS = getButtonsConfig(additionalDetails);
  return (
    <GenericModal
      iconName={SvgEnum.HisAlertCircle}
      iconColor={HNSColors.failure[500]}
      iconBgColor={HNSColors.failure[700]}
      title="Warning"
      titleColor={HNSColors.failure[500]}
      message={
        <Typography>
          {"Are you sure you want to delete this item?"} <br></br>
          <span style={{ color: HNSColors.failure[500], fontWeight: 600 }}>
            *Please Note: This action can not be undone.
          </span>
        </Typography>
      }
      buttons={[BUTTONS.CANCEL, BUTTONS.DELETE]}
    />
  );
}
